@if ((account$ | async)?.capabilities?.includes(ECapabilities.ADMINISTRATIVE_DOCUMENTS)) {
  <h2>{{ 'company.company_docs' | translate }}</h2>

  <lib-message-ui-ionic [messages]="messages"></lib-message-ui-ionic>

  <div class="block-content-round ion-padding-horizontal-0">
    <ion-list class="ion-no-padding ion-no-margin">
      @for (document of companyDocuments$ | async; track $index) {
        <ion-item
          [ngClass]="{
            empty: !document.id,
            expired: document.expiresOn && document.expiresOn.getTime() < todayTimestamp,
          }"
        >
          <ion-label>
            @if (!document.id) {
              <div class="notice">
                <p>
                  {{ 'general.not_upload_document' | translate | uppercase }}
                </p>
                <ion-icon
                  slot="start"
                  aria-hidden="true"
                  src="../assets/material-symbols/notification_important_FILL0_wght400_GRAD0_opsz24.svg"
                ></ion-icon>
              </div>
            }
            @if (document.expiresOn && document.expiresOn.getTime() < todayTimestamp) {
              <div class="notice">
                <p>
                  {{ 'general.expired_document' | translate | uppercase }}
                </p>
                <ion-icon
                  slot="start"
                  aria-hidden="true"
                  src="../assets/material-symbols/notification_important_FILL0_wght400_GRAD0_opsz24.svg"
                ></ion-icon>
              </div>
            }

            @if (document.type === EDocumentType.BANK_OWNERSHIP_CERTIFICATE) {
              <p>
                <strong>{{ 'company.bank_certificate' | translate }}</strong>
              </p>
              @if (document.description) {
                <p>
                  <strong>{{ 'company.iban' | translate }}</strong>
                  {{ document.description }}
                </p>
              }
            } @else if (document.type === EDocumentType.TAX_AUTHORITIES_PAYMENT_CERTIFICATE) {
              <p>
                <strong>{{ 'company.tax_certificate' | translate }}</strong>
              </p>
            } @else if (document.type === EDocumentType.SOCIAL_SECURITY_PAYMENT_CERTIFICATE) {
              <p>
                <strong>{{ 'company.ss_certificate' | translate }}</strong>
              </p>
            } @else if (document.type === EDocumentType.ACTIVITY_LICENSE) {
              <p>
                <strong>{{ 'company.al_certificate' | translate }}</strong>
              </p>
            } @else if (document.type === EDocumentType.EUROPEAN_LICENSE) {
              <p>
                <strong>{{ 'company.el_certificate' | translate }}</strong>
              </p>
            } @else if (document.type === EDocumentType.GOODS_ASSURANCE) {
              <p>
                <strong>{{ 'company.ga_certificate' | translate }}</strong>
              </p>
              @if (document.description) {
                <p>
                  <strong>{{ 'company.assurance_quantity' | translate }}</strong>
                  {{ document.description }}
                </p>
              }
            } @else if (document.type === EDocumentType.CIVIL_RESPONSABILITY_ASSURANCE) {
              <p>
                <strong>{{ 'company.cra_certificate' | translate }}</strong>
              </p>
            }

            @if (document.createdAt) {
              <!-- TODO pending get modifiedAt or createdAt updated -->
              <!-- <p>{{ 'company.updated_on' | translate }} {{ document.createdAt | dfnsFormat: 'PPPPp' }}</p> -->
              <p>{{ 'company.valid_to' | translate }} {{ document.expiresOn | dfnsFormat: 'PPPP' }}</p>
            }

            @if (document.url) {
              <ion-button
                fill="outline"
                size="small"
                (click)="downloadDocument(document.url)"
              >
                <ion-icon
                  src="../assets/material-symbols/visibility_24dp_FILL0_wght400_GRAD0_opsz24.svg"
                  slot="start"
                ></ion-icon>
                {{ 'general.download' | translate }}
              </ion-button>
            }

            <lib-upload-document-button [documentType]="document.type"></lib-upload-document-button>
          </ion-label>
        </ion-item>
      }
    </ion-list>
  </div>
}

@if ((account$ | async)?.capabilities?.includes(ECapabilities.VIEW_PRICES)) {
  <lib-fastpay-card-cta></lib-fastpay-card-cta>
}
